"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
exports.__esModule = true;
var react_1 = require("react");
var reducer = function reducer(previousState, updatedState) {
  return __assign(__assign({}, previousState), updatedState);
};
var useObject = function useObject(initialState) {
  var _a = (0, react_1.useReducer)(function (previousState, updatedState) {
      return reducer(previousState, updatedState);
    }, initialState),
    state = _a[0],
    dispatch = _a[1];
  var setState = function setState(updatedState) {
    return dispatch(updatedState);
  };
  return [state, setState];
};
exports["default"] = useObject;